import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type LongTextPreviewProps = {
  questionIndex: number;
};
const LongTextPreview = t0 => {
  const $ = _c(22);
  const {
    questionIndex
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  const t3 = `questions.${questionIndex}.placeholder`;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = [t1, t2, t3];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== control || $[5] !== t4) {
    t5 = {
      control,
      name: t4
    };
    $[4] = control;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const [label, required, placeholder] = useWatch(t5);
  let t6;
  if ($[7] !== t) {
    t6 = trimmed => t(_temp, {
      label: trimmed
    });
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== label || $[10] !== required || $[11] !== t6) {
    t7 = previewLabel(label, required, t6);
    $[9] = label;
    $[10] = required;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const labelWithOptional = t7;
  let t8;
  if ($[13] !== labelWithOptional) {
    t8 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[13] = labelWithOptional;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `questions.${questionIndex}.preview`;
  let t10;
  if ($[15] !== placeholder || $[16] !== t) {
    t10 = placeholder || t(_temp2);
    $[15] = placeholder;
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = <Form.Textarea label={t8} name={t9} placeholder={t10} rows={4} />;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default LongTextPreview;
function _temp($) {
  return $.preview.labelOptional;
}
function _temp2($_0) {
  return $_0.preview.yourAnswer;
}